import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Menu, { MenuItem } from 'components/common/Menu';

import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

const styles = () => ({
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 308,
    borderTop: 'none',
    paddingTop: 8,
    paddingBottom: 8,
    height: 'auto',
    whiteSpace: 'normal',
    textAlign: 'left',
  },
  gridItem: {
    display: 'flex',
  },
  gridItemBMI: {
    minWidth: 76,
  },
});

const OrderInformationVitalsMenu = ({
  open,
  anchorEl,
  id,
  onClose,
  onCreateButtonClick,
  Vitals,
  onItemClick,
  classes,
}) => (
  <Menu
    id={id}
    anchorEl={anchorEl}
    open={open}
    {...onClose ? { onClose } : {}}
    onListAdornmentClick={onCreateButtonClick}
    listAdornmentText="Add From List"
  >
    {Vitals.map(vitalsItem => (
      <MenuItem
        className={classes.menuItem}
        key={vitalsItem.ID}
        {...onItemClick ? { onClick: () => { onItemClick(vitalsItem); } } : {}}
      >
        <Grid
          container
          justify="flex-start"
          wrap="nowrap"
          spacing={16}
        >
          <Grid
            className={classes.gridItem}
            item
          >
            <Typography
              component="span"
              color="secondary"
            >
              W
            </Typography>
            {'\u00A0'}
            <Typography
              component="span"
            >
              {vitalsItem.Weight}{'\u00A0'}lb
            </Typography>
          </Grid>
          <Grid
            className={classes.gridItem}
            item
          >
            <Typography
              component="span"
              color="secondary"
            >
              H
            </Typography>
            {'\u00A0'}
            <Typography
              component="span"
            >
              {vitalsItem['Height Ft']}ft
              {vitalsItem['Height In'] > 0 && (
                `,\u00A0${vitalsItem['Height In']}in`
              )}
            </Typography>
          </Grid>
          <Grid
            className={classNames(classes.gridItem, classes.gridItemBMI)}
            item
          >
            <Typography
              component="span"
              color="secondary"
            >
              BMI
            </Typography>
            {'\u00A0'}
            <Typography
              component="span"
            >
              {vitalsItem.BMI}
            </Typography>
          </Grid>
          <Grid
            className={classes.gridItem}
            item
          >
            <Typography
              component="span"
            >
              {moment(vitalsItem['Create At'], timeDateFormat).format(dateFormat)}
            </Typography>
          </Grid>
        </Grid>
      </MenuItem>
    ))}
  </Menu>
);

OrderInformationVitalsMenu.propTypes = {
  open: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.object,
  onClose: PropTypes.func,
  Vitals: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'BMI': PropTypes.number,
    'Weight': PropTypes.number,
    'Height Ft': PropTypes.number,
    'Height In': PropTypes.number,
    'Create At': PropTypes.string,
  })),
  id: PropTypes.string,
  onItemClick: PropTypes.func,
  onCreateButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    menuItem: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationVitalsMenu.defaultProps = {
  open: false,
  anchorEl: null,
  id: null,
  onClose: null,
  Vitals: [],
  onItemClick: null,
  onCreateButtonClick: null,
};

export default withStyles(styles)(OrderInformationVitalsMenu);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationVitals/OrderInformationVitalsMenu.js